// extracted by mini-css-extract-plugin
export default {"container":"gZ-z","list":"hZ-z"};